// extracted by mini-css-extract-plugin
module.exports = {"root":"TOC_root__74GSj","list":"TOC_list__3PSfP","section":"TOC_section__1M_K8","title":"TOC_title__uqNyY"};